import React from 'react';
import './NoAuth.scss';


const NoAuth: React.FC = () => {
    return (
        <div className='no-auth-container'>
            <h1>Acceso no autorizado</h1>
            <p> Su administrador no lo ha autorizado para acceder a este contenido </p>
        </div>
    );
};

export default NoAuth;